/**
 * API configuration - validates and exposes the base API URL
 */

const url = import.meta.env.VITE_API_URL as string | undefined;

if (!url) {
  const error = new Error('VITE_API_URL environment variable is required');

  // Send error to GTM if available
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'configuration_error',
      error_type: 'missing_api_url',
      error_message: error.message
    });
  }

  throw error;
}

// Ensure the URL ends with a slash to preserve the path when constructing relative URLs
const normalizedUrl: string = url.endsWith('/') ? url : url + '/';

// Export the URL object directly for flexible usage
export const API_BASE_URL: URL = new URL(normalizedUrl);